import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

import { suggestTimeZones } from '@api/suggestions';
import { matchError } from '@api/util';
import { OrganizationRegistration } from '@model/employer';
import { TimeZone } from '@monjin/data/model/Profile';
import { TelephoneNumber } from '@monjin/vue-toolkit/TelephoneInput/TelephoneInput';
import { hasString, isNumeric } from '../../../util/index';

import WithRender from './AboutYourself.html';

@WithRender
@Component({
    validations: {
        firstName: { required },
        lastName: { required },
        mobileNumber: {
            required: (x: TelephoneNumber) => x.dialNumber.length > 0,
            isValidInput: (x: TelephoneNumber) => x && x.dialNumber.length > 3 && x.dialNumber.length < 14,
            isNumeric: (x: TelephoneNumber) => x && isNumeric(x.dialNumber)
        },
        selectedTimezone: { isValidInput: (x) => x && x.id !== -1 }
    }
})
export default class AboutYourself extends Vue {

    @Prop()
    public orgData: OrganizationRegistration;

    public $v: any;

    public errorMessage: string = '';

    public unknownError: boolean = false;

    public firstName: string = '';

    public lastName: string = '';

    public mobileNumber: TelephoneNumber = {
        dialCode: -1,
        dialNumber: ''
    };

    public timezoneSearch: string = '';

    public timezones: TimeZone[] = [];

    public selectedTimezone: TimeZone = {
        id: -1,
        name: '',
        offset: 0
    };

    public created() {
        this.firstName = this.orgData.adminFirstName;
        this.lastName = this.orgData.adminLastName;
        this.mobileNumber = {
            dialCode: parseInt(this.orgData.adminDialCode, 10),
            dialNumber: this.orgData.adminPhoneNumber
        };
        this.selectedTimezone = this.orgData.timezone;

        suggestTimeZones()
            .then((data) => this.timezones = data)
            .catch(matchError({
                anyError: () => {
                    const message = 'Something went wrong!';

                    this.errorMessage = message;
                    this.unknownError = true;
                    this.$snackbar.error({ message });
                }
            }));
    }

    public get timezoneOpts() {
        return this.timezones
            .filter((x) => hasString(x.name, this.timezoneSearch));
    }

    public hasError(model: string) {
        return this.$v.$dirty && this.$v[model].$error;
    }

    public onSubmit() {
        // Dirty all inputs
        this.$v.$touch();

        if (this.$v.$invalid) {
            return;
        }

        const data = {
            firstName: this.firstName,
            lastName: this.lastName,
            mobileNumber: this.mobileNumber,
            timezone: this.selectedTimezone
        };

        this.$emit('next', 3, data);
    }

    public onSearch(key: string, q: string) {
        // key is one of the search string:
        this[key] = q;
    }

    public toText(x: TimeZone) {
        return x.name;
    }
}
